export default __webpack_public_path__ + "static/media/041-starfish.bff0c0bb.png";